import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  FormLabel,
  Input,
  Select,
  Stack,
  Textarea,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import { AddIcon } from "@chakra-ui/icons";
import {
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { useParams } from "react-router-dom";
import { UserAuth } from "../auth/AuthContext";
import { db } from "../firebase-config";

const initialState = {
  date: "",
  // detalhe_c: "",
  reason: "",
  resumo: "",
  valor: 0,
};

const AddEvent = ({ getEvents }) => {
  const [isDisabled, setIsDisabled] = useState(false); // Desabilitar botão após submit para evitar duplicação
  const { carroId, filialId } = useParams();
  const toast = useToast();
  const { user } = UserAuth();
  useEffect(() => {
    carroId, filialId;
  }, [carroId, filialId]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const firstField = React.useRef();

  const [addData, AddSetData] = useState(initialState);

  const { date, detalhe_c, reason, resumo, valor } = addData;

  useEffect(() => {
    carroId, filialId;
  }, [carroId, filialId]);

  const CreateEvent = async () => {
    setIsDisabled(true);

    if (!user.displayName) {
      ToastUserError();
      setIsDisabled(false);
      return;
    }

    if (!date || !reason || !resumo) {
      ToastValidationError();
      setIsDisabled(false);
      return;
    }

    if (valor !== "" && isNaN(parseFloat(valor))) {
      setIsDisabled(false);
      toast({
        title:
          "Valor inválido, insira apenas números, caso seja fração, pode usar virgulas. Caso não tenha valor, digite 0",
        position: "top",
        status: "error",
        variant: "top-accent",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    const eventosRef = doc(
      db,
      "/FILIAIS/91IYpjJbXYN99Asq2Enw/",
      filialId,
      carroId,
      "Eventos",
      "docEventos"
    );

    const docSnap = await getDoc(eventosRef);
    const updatedData = {
      ...addData,
      criador: user.displayName,
      uidcriador: user.uid,
      createdAt: Timestamp.now(),
    };
    if (docSnap.exists()) {
      await updateDoc(eventosRef, {
        ArrayEvents: arrayUnion(updatedData),
      });
    } else {
      await setDoc(eventosRef, { ArrayEvents: arrayUnion(updatedData) });
    }

    onClose();
    ToastEventAdd();
    handleReset();
    setIsDisabled(false);
  };

  const handleChange = (e) => {
    const value =
      e.target.name === "valor" ? parseFloat(e.target.value) : e.target.value;

    AddSetData({
      ...addData,
      [e.target.name]: value,
    });
  };

  const ToastValidationError = () => {
    return toast({
      title: `Por favor, preencha todos os campos antes de enviar!`,
      position: "top",
      status: "error",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  const handleReset = () => {
    setTimeout(() => {
      getEvents();

      AddSetData(initialState);
    }, 1000);
  };

  const ToastEventAdd = () => {
    return toast({
      title: "Evento cadastrado com sucesso!",
      position: "top",
      status: "success",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  const ToastUserError = () => {
    return toast({
      title: `Erro, usuário não identificado, faça login novamente!`,
      position: "bottom",
      status: "error",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  const validateForm = () => {
    return (
      date !== "" &&
      // detalhe_c !== "" &&
      reason !== "" &&
      resumo !== "" &&
      valor !== ""
    );
  };

  const handleKeyPress = (e) => {
    if (e.key === "e") {
      e.preventDefault();
    }
  };

  return (
    <>
      <Button
        leftIcon={<AddIcon />}
        colorScheme="green"
        onClick={onOpen}
        name="addEvento"
        size="sm"
      >
        Adcionar Evento
      </Button>

      <Drawer
        isOpen={isOpen}
        placement="bottom"
        initialFocusRef={firstField}
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Cadastrar Evento</DrawerHeader>

          <DrawerBody>
            <Stack spacing="24px">
              <Box>
                <FormLabel htmlFor="reason">MOTIVO:</FormLabel>
                <Select
                  id="reason"
                  name="reason"
                  variant="filled"
                  value={reason}
                  onChange={handleChange}
                >
                  <option value="Não Informado">-</option>
                  <option value="REVISÃO">REVISÃO</option>
                  <option value="MANUTENÇÃO">MANUTENÇÃO</option>
                  <option value="COMPRA">COMPRA</option>
                  <option value="SUBSTITUIÇÃO">SUBSTITUIÇÃO</option>
                  <option value="COMBUSTÍVEL">COMBUSTÍVEL</option>
                  <option value="MULTA">MULTA</option>
                </Select>
              </Box>

              {/* <Box>
                <FormLabel htmlFor="detalhe_c">Detalhe curto</FormLabel>
                <Input
                  id="detalhe_c"
                  name="detalhe_c"
                  value={detalhe_c}
                  placeholder="Digite o detalhe curto"
                  onChange={handleChange}
                />
              </Box> */}

              <Box>
                <FormLabel htmlFor="Data">Data</FormLabel>
                <Input
                  type="date"
                  name="date"
                  value={date}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="Valor">Valor</FormLabel>

                <Input
                  type="number"
                  name="valor"
                  value={parseFloat(valor)}
                  onChange={handleChange}
                  placeholder="Valor"
                />
              </Box>

              <Box>
                <FormLabel htmlFor="resumo">Resumo</FormLabel>
                <Textarea
                  id="resumo"
                  name="resumo"
                  value={resumo}
                  onChange={handleChange}
                />
              </Box>
            </Stack>
          </DrawerBody>

          <DrawerFooter borderTopWidth="1px">
            <Button variant="outline" mr={3} onClick={onClose}>
              Fechar
            </Button>

            {isDisabled ? (
              <Button
                isLoading
                loadingText="Cadastrando..."
                colorScheme="blue"
                spinnerPlacement="end"
              ></Button>
            ) : (
              <Button colorScheme="green" onClick={CreateEvent}>
                Cadastrar
              </Button>
            )}
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default AddEvent;
